export default class LogManager{
    static getInstance(){
        if (window.env === 'prod' || window.env === 'stage'){
            return new ProdLogManager();
        }
        return new LogManager();
    }

    constructor(){

    }

    // log in whatever condition
    logForSure(){
        console.log(...arguments);
    }

    info(){
        console.info(...arguments);
    }

    log(){
        console.log(...arguments);
    }

    warn(){
        console.warn(...arguments);
    }

    error(){
        console.error(...arguments);
    }
}

class ProdLogManager extends LogManager{
    constructor(){
        super()
    }

    info(){
        // do nothing
    }

    log(){
        // do nothing
    }

    warn(){
        console.warn(...arguments);
    }

    error(){
        console.error(...arguments);
    }
}